import React from 'react';

const OrdersSkeleton = () => {
  // Generate multiple skeleton rows
  const generateSkeletonRows = (count) => {
    return Array(count)
      .fill(0)
      .map((_, index) => (
        <tr key={index} className="animate-pulse">
          <td className="py-2 px-2 sm:px-4 whitespace-nowrap">
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </td>
          <td className="py-2 px-2 sm:px-4 whitespace-nowrap">
            <div className="h-4 bg-gray-200 rounded w-24"></div>
          </td>
          <td className="py-2 px-2 sm:px-4">
            <div className="h-4 bg-gray-200 rounded w-20 mb-1"></div>
            <div className="h-3 bg-gray-200 rounded w-16 hidden sm:block"></div>
          </td>
          <td className="py-2 px-2 sm:px-4 whitespace-nowrap hidden sm:table-cell">
            <div className="h-4 bg-gray-200 rounded w-16"></div>
          </td>
          <td className="py-2 px-2 sm:px-4 whitespace-nowrap">
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </td>
          <td className="py-2 px-2 sm:px-4 hidden md:table-cell">
            <div className="h-4 bg-gray-200 rounded w-16 mb-1"></div>
            <div className="h-6 bg-gray-200 rounded w-14 mt-1"></div>
          </td>
          <td className="py-2 px-2 sm:px-4 whitespace-nowrap">
            <div className="h-6 bg-gray-200 rounded w-16"></div>
          </td>
          <td className="py-2 px-2 sm:px-4 whitespace-nowrap">
            <div className="h-8 bg-gray-200 rounded w-12"></div>
          </td>
        </tr>
      ));
  };

  return (
    <div className="container mx-0 px-4 sm:px-4 bg-_white pt-6 rounded-md">
      {/* Orders Table Skeleton */}
      <div className="overflow-x-auto -mx-2 sm:mx-0">
        <div className="inline-block min-w-full align-middle">
          <div className="overflow-hidden border border-gray-lite rounded-lg">
            <table className="min-w-full divide-y divide-gray-lite">
              <thead className="bg-bg-dark text-_gray">
                <tr>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider">Order ID</th>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider">Date</th>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider">Customer</th>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider hidden sm:table-cell">City</th>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider">Total</th>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider hidden md:table-cell">Payment</th>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider">Status</th>
                  <th scope="col" className="py-2 px-2 sm:px-4 text-left text-xs font-medium uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="bg-_white divide-y divide-gray-lite">
                {generateSkeletonRows(5)} {/* Generate 5 skeleton rows */}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      {/* Pagination Skeleton */}
      <div className="flex flex-col sm:flex-row justify-between items-center mt-4 gap-2 animate-pulse">
        <div className="h-4 bg-gray-200 rounded w-32 order-2 sm:order-1"></div>
        <div className="flex gap-2 order-1 sm:order-2 w-full sm:w-auto">
          <div className="h-8 bg-gray-200 rounded w-20 flex-1 sm:flex-none"></div>
          <div className="h-8 bg-gray-200 rounded w-20 flex-1 sm:flex-none"></div>
        </div>
      </div>
    </div>
  );
};

export default OrdersSkeleton;